export const seven = [
  {
    path: "exhibition-7th",
    basic: {
      type: "expo",
      name: "吾敘Störung",
      tag: "吾敘，那個傳說中的天堂，聽說那裡只有無盡的寧靜祥和，不必燃燒，無須掙扎。",
      square: "7th-expo-square.jpg",
      banner: "7th-expo-banner.jpg",
      startDate: "Nov 30, 2022 15:00:00",
      dateRange: "2022/11/30 ~ 2022/12/4",
      time: "10:00-18:00",
      location: "台灣大學學生活動中心B1",
      button: null,
    },
    description: [
      "自吾之口，敘世界",
      "世界之始，在盤古開天、上帝創世之前，混沌而無章的世界，意外的，在寧靜的平衡之中沈睡數十個世紀",
      "民智初開，朝氣蓬勃的人們驚天破地的建立起文明、制度",
      "秩序橫跨在歷史的河流，像救命之木，以基石之姿，承載起社會的運行",
      "吾敘，那夢中自由的無序",
      "曾經的秩序如同枷鎖，將人們綁縛在那條大河，載浮載沉，時而奮起爭扎",
      "可惜色彩鮮豔的小船終將燃盡熱情，任由秩序的浪潮沖刷著斑駁的自己",
      "吾敘，那個傳說中的天堂",
      "聽說那裡只有無盡的寧靜祥和",
      "不必燃燒，無須掙扎",
      "",
      "This is a story of “Störung”, or chaos.",
      "At the beginning of time, there was nothing but different substances floating around in empty Space, maintaining a perfect and peaceful balance. The“Bigbang” broke the balance, creating the universe and subsequently our world. ",
      "Civilization soon began, and with that came the erection of order. Our ancestors created massive pillars of order that profoundly influenced human societies for thousands of years.",
      "However, we have grown discontent with simply following orders set millennia ago.",
      "We dream of freedom, free from the shadow of the massive pillars of order. Where people are no longer burdened by conventions and chained by countless rules.",
      "We wonder about heaven. Where there is rumored to be infinite peace and calm.",
    ],
    info: [
      "年展主題｜吾敘Störung",
      "年展日期｜11/30-12/3 10:00-18:00；12/4 10:00-16:00",
      "年展地點｜台灣大學學生活動中心B1 免費入場",
    ],
    guestlist: null,
    sponsorlist: null,
    video: {
      title: "籌備紀錄片",
      src: "https://www.youtube.com/embed/OjwlJbPwgVI",
    },
  },
  {
    path: "workshop1-7th",
    basic: {
      type: "workshop",
      name: "統一證券工作坊",
      tag: "台大TEDx這學期第一個活動要開跑囉！這次舉辦的工作坊邀請到統一證券，與大家分享投資入門知識。",
      square: "7th-workshop1-square.jpg",
      banner: "7th-workshop1-banner.jpg",
      startDate: "Nov 12, 2022 14:00:00",
      dateRange: "2022/11/12",
      time: "14:00 - 16:20",
      location: "台灣大學普通教學館102 教室",
      button: null,
    },
    description: [
      "台大TEDx這學期第一個活動要開跑囉！這次舉辦的工作坊邀請到統一證券，與大家分享投資入門知識，有興趣的朋友趕快來報名～想知道更多講者資訊，請持續關注TEDx粉專！",
    ],
    info: [
      "時間｜11/12（六）14:00 - 16:20，13:40開放入場",
      "地點｜台灣大學普通教學館102 教室",
    ],
    guestlist: null,
    sponsorlist: null,
    video: null,
  },
];

export const six = [
  {
    path: "tedx-6th",
    basic: {
      type: "tedx",
      name: "理想麻醉 Dream Paralysis",
      tag: "麻醉就像一場霧，霧中的我們不斷掙扎於現實與理想間，痛並快樂著。",
      square: "6th-tedx-square.jpg",
      banner: "6th-tedx-banner.jpg",
      startDate: "May 15, 2022 15:00:00",
      dateRange: "2022/5/15",
      time: "13:00 ~ 16:00",
      location: "台灣大學 梁國樹國際會議廳",
      button: ["立即購票", "https://www.accupass.com/go/6thtedxntu"],
    },
    description: [
      "麻醉就像一場霧，霧中的我們不斷掙扎於現實與理想間，痛並快樂著。",
      "我終於走進由華燈交織、五光十色的大城，像是來到了全新的世界。夜晚的降臨不但沒有帶來黑暗和恐懼，而是使其更加絢爛，令人心醉神搖。",
      "迷離的燈火中，每一扇門的後面似乎都藏著新奇的事物，等著我去發現、去探索，然而在這些華麗的大門之前，卻又透著令人緊張的氣氛。門邊街上的遊人來來去去，有的躊躇滿志、有的垂頭喪氣、還有的不停的在門前徘徊，人人心中都懷著期待和不安。門前的人們看起來是如此渺小，似乎被這氣勢萬鈞的城市壓得喘不過氣來。",
      "大街上，看著街邊的櫥窗擺滿了美所設計而成的物件，人們來去、偶而駐足賞之，好似城市裡每個人無時不刻被評論的象徵；路口處，巨型LED燈板上輪番播放著外交和政治新聞，穿插著商業所構築對未來的美好想像，是城市的脈搏，每閃一下都牽動著人的命運和心情；廣場上的歌手吟唱著自己的過往傷痛和迎向未來的勇氣，溫暖的歌聲治癒著人們；走到馬路邊，車子呼嘯而過，紅綠燈和感應式的街燈隨著煞車聲亮起，為黑暗的街道亮起了一盞盞明燈。",
      "嘈雜而燦爛的世界，我們像身在由華燈構成的霧中，陷落於理想卻又像魚般被迫拉扯回現實，掙扎自我認同時牽動傷口鮮血淋漓卻又麻痺於理想，痛並快樂著。",
    ],
    info: [
      "時間 | 5/15 (日) 13:00 - 16:00 (12:30 寄送連結)",
      "地點 | 台灣大學社會科學院 梁國樹國際會議廳",
    ],
    guestlist: ["張倞菱", "陳昱築", "王淳", "黃暐程", "劉致昕", "潘瑋翔"],
    sponsorlist: null,
    video: null,
  },
  {
    path: "pretedx3-6th",
    basic: {
      type: "pre",
      name: "TEDx 放大鏡 TEDXD",
      tag: "本次會前活動希望藉由邀請各校歷屆 TEDx 籌辦幹部, 與本屆台大策辦團隊、年會觀眾一同分享專屬於每屆的小故事。",
      square: "6th-pre3-square.jpg",
      banner: "6th-pre3-banner.jpg",
      startDate: "May 5, 2022 19:00:00",
      dateRange: "2022/5/5",
      time: "19:00 ~ 21:00",
      location: "台灣大學 新生教學館 505室",
      button: null,
    },
    description: [
      "TEDXD = TSC Event Disclose X Discover",
      "舉辦一個百人以上參加的 TEDx 年會活動需要的準備工作，每一項都需要投注大量心力。除了繁複的前置作業,更要在籌辦的過程中注意許多細節,像是維持 TED 分享社的核心理念,共同維護這個品牌價值。      ",
      "本次會前活動希望藉由邀請各校歷屆 TEDx 籌辦幹部, 與本屆台大策辦團隊、年會觀眾一同分享專屬於每屆的小故事,進一步讓大眾對 TEDx 以及本社團有更深一層的認識。",
      "這次特別邀請到東吳大學以及中央大學的 TEDx 團隊分享，預計可以更進一步交流與討論，並建立 TEDx 各校的連結網落，讓團隊互相學習，舉辦出更具有代表性的TEDx Event！",
    ],
    info: [
      "時間｜5/5 (四) 19:00 - 21:00",
      "地點｜台灣大學 新生教學館 505室",
      "開放登記時間 | 4月25日 12:00",
    ],
    guestlist: ["陳佳愉", "羅信鈞", "吳昕晏", "林源煜", "Evangeline"],
    sponsorlist: null,
    video: null,
  },
  {
    path: "pretedx2-6th",
    basic: {
      type: "pre",
      name: "C世傳說 Tales of the “C”",
      tag: "期中考念累了嗎？本土疫情再次燃起覺得煩躁？快來參加台大TED分享社的單口喜劇之夜！",
      square: "6th-pre2-square.jpg",
      banner: "6th-pre2-banner.jpg",
      startDate: "Apr 22, 2022 19:00:00",
      dateRange: "2022/4/22",
      time: "19:00 ~ 21:00",
      location: "他，在旅行木吉他專賣店 B1劇場",
      button: [
        "立即購票",
        "https://www.accupass.com/event/2204061128281966377631",
      ],
    },
    description: [
      "期中考念累了嗎？本土疫情再次燃起覺得煩躁？快來參加台大TED分享社的單口喜劇之夜！",
      "台大TED分享社會前系列活動第二場：C世傳說 Tales of the “C” ，C為COVID, comedy, consumer, connection之意。本場活動將透過喜劇與遊戲的包裝，呈現後疫情時代娛樂產業的種種現象，試圖引發當今世代的共鳴與反思。",
      "活動形式將結合三場單口喜劇演出與競猜遊戲，其中的單口喜劇演員由台大TED分享社成員或公開徵求之素人擔任，會場也將供應酒水與點心，競猜遊戲的贏家們更能抱回數個精緻大獎。台大TED分享社精心打造小週末情侶約會、朋友聚會、單身者交友的最佳場所！",
      "只要花一杯飲料的錢，就能獲得讓你笑到開懷的優質喜劇體驗，還有機會抱回數個精緻大獎。而且而且，如果持有年會票券，C世傳說門票直接幫你打82折，優惠碼在你訂購年會票券時會一併寄給您（如未收到請私訊粉專）！",
      "所以你還在等什麼？快點手刀訂票吧！",
    ],
    info: [
      "活動日期｜2022年4月22日",
      "活動時間｜19:00 - 21:00 （18:30 - 18:50 入場）",
      "活動收費｜$180 （附一杯酒精飲料）",
      "活動場地｜他，在旅行木吉他專賣店 B1劇場（當日會有工作人員於該店路口指引）",
    ],
    guestlist: ["文組吉姆", "過動兒", "大頭禎", "小籠包", "油條"],
    sponsorlist: null,
    video: {
      title: "活動宣傳片",
      src: "https://www.youtube.com/embed/q46CKMCShOk",
    },
  },
  {
    path: "pretedx1-6th",
    basic: {
      type: "pre",
      name: "感應 Accommodation",
      tag: "此次講座將會探討 NFT 相關議題，並希冀透過講者的親身經歷，分享如何在困難重重的疫情中展現出創作成果。",
      square: "6th-pre1-square.jpg",
      banner: "6th-pre1-banner.jpg",
      startDate: "Mar 26, 2022 14:00:00",
      dateRange: "2022/3/26",
      time: "14:00 ~ 17:00",
      location: "台灣大學博雅教學館 103 教室",
      button: [
        "立即登記",
        "https://www.accupass.com/event/2203151409517738594840",
      ],
    },
    description: [
      "「感應」取自「改變」與「適應」的諧音，在新冠肺炎肆虐的這兩年中，無論是身邊的任何人，不管是主動的或是被動的，都能感受到病毒所帶來的危險與威脅。",
      "疫情改變了世界，在藝術的創作與欣賞上亦是如此。以民眾的角度而言，眾多實體空間受限後，許多人將他們的目光投射在數位藝術品上，透過網路世界欣賞藝術。另外以創作者的角度而言，亦無法掙脫疫情的漩渦，轉而透過網路平台、線上藝廊等發佈自身作品。",
      "因此在疫情尚未知曉何時迎來終結下，無論是創作者、觀眾，都需要去適應新興的藝術呈現方式。",
      "近年來，由於數位藝術的盛行，NFT (Non – Fungible Token) 的藝術品形式也逐漸的受到創作者、藏家的親睞，透過相關的技術，將虛擬世界與現實形象相結合，突破空間的侷限，走入大眾的視野中。",
      "因此，此次講座將會探討 NFT 相關議題，並希冀透過講者的親身經歷，分享如何在困難重重的疫情中展現出創作成果，並讓參與者了解創作者藉由 NFT 形式發佈作品的契機與想法，以及藝術家在面對疫情所帶來改變的同時，心態上如何重塑與適應，將 NFT 與藝術相結合，創造新興的創作模式。",
    ],
    info: [
      "時間 | 3/26 ( 六 ) 14:00 - 17:00",
      "地點 | 博雅教學館 103 教室",
      "開放登記時間 | 3/17 ( 四 )，此為免費活動",
    ],
    guestlist: [
      "寶博士 dAb 葛如鈞",
      "何以諾 Enoch Ho",
      "呂季潔 Justine Lu",
      "董怡君 Julia Tung",
      "鳳梨三明治 Funnysandwich 謝禎",
      "簡少年",
    ],
    sponsorlist: null,
    video: null,
  },
  {
    path: "exhibition-6th",
    basic: {
      type: "expo",
      name: "長日盡處 At the Day's End",
      tag: "長日盡處，我站在你的面前，你將看到我的疤痕，知道我曾經受傷，也曾經痊癒。",
      square: "6th-expo-square.jpg",
      banner: "6th-expo-banner.jpg",
      startDate: "Dec 14, 2021 09:30:00",
      dateRange: "2021/12/14 ~ 2021/12/17",
      time: "9:30 - 17:30",
      location: "臺灣大學第一學生活動中心 B1",
      button: null,
    },
    description: [
      "「長日盡處，我站在你的面前，你將看到我的疤痕，知道我曾經受傷，也曾經痊癒。」— 泰戈爾《漂鳥集》",
      "浩浩湯湯的時間洪流，幕天黑暗有時無聲蔓延、有時驀然降臨，隨之而來的衝擊、無暇治癒的累累傷痕和面對未知的失措徬徨，隨我們攀著形色各異的奇岩，眼看這長河洶湧，一遍遍托拽著掙扎向上探頭的微塵眾。",
      "二零二零年，冬季，疫情浸透了生活，絕望漫入縫隙，秩序龜裂，希望和目標的碎片劃破肌理；二零二一年，冬季，疫情漣漪不止，而間隙中落灰的渴盼折射了杲杲日光，我們隨光拾起散亂而迷茫的自我，拼貼共存。",
      "縱使被恐懼和未知攫住雙眸，我們仍願在此中摸索前路，竭盡全力緊攥任何一絲微小的、重拾光明的可能，並再次懷揣著初生之犢的勇氣，莽撞地前行。途中荊棘遍布、舉步維艱，我們在跌跌撞撞中化解衝突、打破對立、相互扶持，最終與自己和解。",
      "我們始終深信，黑夜總會過去，黎明的曙光將帶著溫柔擁我們入懷。傷痕終將成為鎧甲，包裹脆弱，堅韌地一齊披荊斬棘；而榮光將照亮彼方，指引我們無所畏懼地前行。",
      "長日盡處，等待我們的是漫漫長夜，也是下一個天明。邀請您，來參與台大 TED 分享社年度展覽，讓我們一同踏上一條尋回迷惘的自己的路，與衝突對立和解，無所畏懼地擁抱明天。",
      "",
      "“ When I stand before thee at the day’s end, thou shalt see my scars and know that I had my wounds and also my healing ”, Tagore, Stray Birds.",
      "Every so often, unforeseen events arise, sending shocks and chaos through our everyday lives. These impacts frequently leave us scarred and helpless, desperate for a reprieve from turbulence and unpredictability.",
      "Winter, 2020. The pandemic had seeped into every aspect of our lives, altering our norms and aspirations. Winter, 2021. The pandemic remains, but we have started to embrace a new paradigm, picking up pieces from our shattered past and rearranging them into a more vigorous future.",
      "Even though our fear for the unknown persists, we have begun to venture out once more, striving to break free from the shackles that have restricted us for so long. The road ahead is perilous, yet it is in fact these challenges that will aid us in resolving conflicts, reconciling oppositions, and ultimately making peace with ourselves.",
      "At the day’s end, darkness will always recede eventually, allowing for rays of hope to shine through the horizon once more. We cordially invite you to join us at our annual exhibition to take a moment to reexamine ourselves and reconcile our internal conflicts. Let us all re-emerge stronger and more assertively.",
    ],
    info: [
      "展覽時間 ︳12/14（二）— 12/17（五）9:30 - 17:30",
      "展覽地點 ︳臺灣大學第一學生活動中心 B1 免費入場",
      "Date | 12/14 (Tue) - 12/17 (Fri) 9:30-17:30",
      "Location | First Student Activity Center B1 Gallery, Free Admission",
    ],
    guestlist: null,
    sponsorlist: null,
    video: {
      title: "籌備紀錄片",
      src: "https://www.youtube.com/embed/KCkDiDhgj9k",
    },
  },
];

export const five = [
  {
    type: "tedx",
    name: "如果世界是斜的",
    square: "5th-tedx-square.jpg",
    tag: "挑戰異常的俠義定義，打造傾斜的世界",
  },
  {
    type: "workshop",
    name: "我&世界的角度差",
    square: "5th-extra-square.jpg",
    tag: "逃離主流價值觀，活出自己想要的生活",
  },
  {
    type: "expo",
    name: "異形溫柔",
    square: "5th-expo-square.jpg",
    tag: "跨越差異，尋找你我間獨特的溫柔",
  },
];

export const four = [
  {
    type: "tedx",
    name: "To Myself",
    square: "4th-tedx-square.jpg",
    tag: "如果人生是個填空題，你的答案會是甚麼",
  },
  {
    type: "expo",
    name: "單點結構",
    square: "4th-expo-square.jpg",
    tag: "「單點」在「結構」過程中的迷惘",
  },
];

export const three = [
  {
    type: "tedx",
    name: "大風吹",
    square: "3rd-tedx-square.jpg",
    tag: "匯聚平凡故事的光亮讓我們日常理所不然",
  },
  {
    type: "expo",
    name: "童玩不完",
    square: "3rd-expo-square.jpg",
    tag: "找回曾懷抱許多理所不然的夢想的自己",
  },
];

export const two = [
  {
    type: "tedx",
    name: "共伴效應",
    square: "2nd-tedx-square.jpg",
    tag: "當兩股慣性凝聚，讓我們迎向彼此碰撞",
  },
  {
    type: "salon",
    name: "相限之外",
    square: "2nd-expo-square.jpg",
    tag: "差異的產生與漫遊自身立場外的可能",
  },
];

export const one = [
  {
    type: "tedx",
    name: "Pitch Day 語匯",
    square: "1st-tedx-square.jpg",
    tag: "讓獨特觀點相互匯聚出生命的多元面貌",
  },
  {
    type: "salon",
    name: "既逝",
    square: "1st-expo-square.jpg",
    tag: "對時間知覺及時間逝去的目的地之看法",
  },
];
